import React from "react";
import * as dc from "dc";
import {format} from 'd3';
import { TotalTemplate } from "./totalTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    //console.log('dim '+this.props.dim)
    const myChart = dc.numberDisplay(divRef);
    const dimension = ndx.dimension(function (d) {
      // var day = d.dincoming.getDate();
      // //console.log(day)
      // var name = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      return d;
    });
    const all = ndx.groupAll();

    const group =  all.reduce(
      function(p, v) { // add
        ++p.count;
        ++p.slevel;
        if(p.count > 0) {
          p.total += Math.floor(parseFloat(v.wait_time));
          p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
          p.serviceLevelTot += v.slevel;
          p.totServiceLevel = Math.floor(parseFloat(100*p.serviceLevelTot/p.count))/100;
          p.tot_conversation_time +=  Math.floor(parseFloat(v.conversation_time));
          p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
        }
        else {
          p.avg = 0;
          p.total = 0;
          p.serviceLevelTot = 0;
          p.totServiceLevel = 0;
          p.tot_conversation_time = 0;
          p.avg_conversation_time = 0;
        }
        return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.total -= Math.floor(parseFloat(v.wait_time));
        p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
        p.serviceLevelTot -= v.slevel;
        p.totServiceLevel = Math.floor(parseFloat(100*p.serviceLevelTot/p.count))/100;
        p.tot_conversation_time -=  Math.floor(parseFloat(v.conversation_time));
        p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.serviceLevelTot = 0;
        p.totServiceLevel = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, total: 0, avg: 0, tot_conversation_time: 0, avg_conversation_time: 0, serviceLevelTot:0,  totServiceLevel: 0};
    }
  );

    myChart
    .formatNumber(format(".0%"))
    .dimension(dimension)
    .group(all)
    .valueAccessor(function (p) {
       return p.totServiceLevel;
     })


    return myChart
}

export class ServiceLevelTotal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TotalTemplate chartFunction={barChartFunc} title={this.props.title}
        dim={this.props.dim} type={this.props.type} >

      </TotalTemplate>

    );
  }
}
